import { render, staticRenderFns } from "./authDisbute.vue?vue&type=template&id=09327786&scoped=true&"
import script from "./authDisbute.vue?vue&type=script&lang=js&"
export * from "./authDisbute.vue?vue&type=script&lang=js&"
import style0 from "./authDisbute.vue?vue&type=style&index=0&id=09327786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09327786",
  null
  
)

export default component.exports